import { DigitalItem } from '@bigcommerce/checkout-sdk';

export interface InvoiceDigitalItem extends DigitalItem {
  invoiceNumber?: number | string;
  invoiceVersion?: string | number
}


export const setDigitalItems = (invoiceVersion: number, digitalItems: InvoiceDigitalItem[]): InvoiceDigitalItem[] => {
    if (+invoiceVersion === 1) {
      digitalItems.forEach((item: InvoiceDigitalItem) => {
        item.invoiceNumber = ''
        item.invoiceVersion = 1
        item.name = 'BC Pay Product'
      })

      return digitalItems
    }

    if (+invoiceVersion === 2) {
      digitalItems.forEach((item: InvoiceDigitalItem) => {
        const {
          options = []
        } = item

        if (options.length) {
          item.invoiceNumber = options[0].value || ''
        }

        item.invoiceVersion = 2

      })

      return digitalItems
    }

  return digitalItems
  
}